export default __webpack_public_path__ + "static/media/User_duotone.9339a8d6.svg";